import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const cookingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createOvenData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/processing-data/cooking/ovens-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['ovenData', 'summaryProcessing', 'ovenList','processingOvenSummary','cartList'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        searchOvenData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/processing-data/cooking/ovens-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['ovenData'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getCartList: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/cart-numbers?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['cartList'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getOvens: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ovens?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['ovenList'],
            async onQueryStarted(_, { queryFulfilled, }) {


                await handleQueryError(queryFulfilled)
            },
        }),
        getItemsType: build.query({
            query: () => {
                return {
                    url: `/item-types`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['itemsList'],
            async onQueryStarted(_, { queryFulfilled, }) {


                await handleQueryError(queryFulfilled)
            },
        }),

        updateOvenData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/processing-data/cooking/ovens-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['ovenData', 'ovenDataById', 'summaryProcessing', 'ovenList', 'packingSummary', 'cheeks', 'strips', 'refrigeration', 'employee', 'packingSummary', 'processingOvenSummary','cartList'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
    }),
});

export const {
    useCreateOvenDataMutation,
    useUpdateOvenDataMutation,
    useSearchOvenDataQuery,
    useGetCartListQuery,
    useGetOvensQuery,
    useGetItemsTypeQuery



} = cookingApi;